import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { partial } from 'lodash';
import BooleanFeedbackButton from '../BooleanFeedbackButton';
import feedbackModes from '../feedbackModes.json';
import styles from './styles.module.styl';

const positiveFeedbackTitle = 'Glad to hear that! Any way we can improve?';
const negativeFeedbackTitle = 'Sorry to hear that. Tell us what happened';

class FeedbackSection extends Component {
  static propTypes = {
    index: PropTypes.number.isRequired
  }

  static contextTypes = {
    trackEvent: PropTypes.func.isRequired
  }

  state = {
    feedbackMode: feedbackModes.NONE,
    showFeedbackModal: false,
    message: ''
  }

  handleMessageChange = (e) => {
    this.setState({ message: e.target.value });
  }

  sendFeedbackEvent = (eventName, eventData) => {
    this.context.trackEvent(
      eventName,
      {
        path: window.location.pathname,
        url: window.location.toString(),
        title: document.title,
        referrer: document.referrer,
        index: this.props.index,
        ...eventData
      }
    );
  }

  handleBooleanFeedback = (isFeedbackPositive) => {
    this.sendFeedbackEvent('submit:quickstarts:code-snippet:feedback-helpful', {
      trackData: isFeedbackPositive
    });

    this.setState({
      feedbackMode: isFeedbackPositive ? feedbackModes.POSITIVE : feedbackModes.NEGATIVE,
      showFeedbackModal: true
    });

    $(document).on('click', this.hideFeedbackModalOnOuterClick);
  }
  handlePositiveFeedback = partial(this.handleBooleanFeedback, true);
  handleNegativeFeedback = partial(this.handleBooleanFeedback, false);

  handleMessageFeedback = () => {
    this.sendFeedbackEvent('submit:quickstarts:code-snippet:feedback-message', {
      trackData: this.state.message,
      track_data2: this.state.feedbackMode
    });
    this.setState({
      feedbackMode: feedbackModes.SENT,
      showFeedbackModal: false
    });
  }

  hideFeedbackModalOnOuterClick = (e) => {
    if (!$(e.target).closest(this.feedbackModal).length) {
      this.setState({ showFeedbackModal: false });
      $(document).off('click', this.hideFeedbackModalOnOuterClick);
    }
  }

  render() {
    const { feedbackMode } = this.state;

    return (
      <div className={styles.feedback}>
        {feedbackMode === feedbackModes.SENT ?
          <span>Thanks for your feedback!</span> :
          <div>
            <span>Did it help?</span>
            <BooleanFeedbackButton
              text="Yes"
              btnFeedbackMode={feedbackModes.POSITIVE}
              currentFeedbackMode={feedbackMode}
              handleClick={this.handlePositiveFeedback}
            />
            <span>/</span>
            <BooleanFeedbackButton
              text="No"
              btnFeedbackMode={feedbackModes.NEGATIVE}
              currentFeedbackMode={feedbackMode}
              handleClick={this.handleNegativeFeedback}
            />
          </div>
        }
        {this.state.showFeedbackModal &&
          <div
            ref={(e) => { this.feedbackModal = e; }}
            className={styles.feedbackModal}
          >
            <div
              className={`
                ${styles.feedbackModalPointer}
                ${styles[feedbackMode.toLowerCase()]}
              `}
            />
            <span className={styles.feedbackModalTitle}>
              {feedbackMode === feedbackModes.POSITIVE && positiveFeedbackTitle}
              {feedbackMode === feedbackModes.NEGATIVE && negativeFeedbackTitle}
            </span>
            <textarea
              cols="30"
              rows="10"
              value={this.state.message}
              onChange={this.handleMessageChange}
            />
            <button
              className={`${styles.feedbackModalBtn} btn btn-primary btn-md`}
              onClick={this.handleMessageFeedback}
              disabled={!this.state.message}
            >
              Send
            </button>
          </div>
        }
      </div>
    );
  }
}

export default FeedbackSection;
